import React from 'react';
import { PROFILE_DATA, TECH_STACK } from '../../data/config';
import { Award, Briefcase, Target } from 'lucide-react';

const About = () => {
  const groupedSkills = TECH_STACK.reduce((acc, skill) => {
    if (!acc[skill.category]) {
      acc[skill.category] = [];
    }
    acc[skill.category].push(skill);
    return acc;
  }, {});

  return (
    <section id="about" className="section-container">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 text-cream-100">About</h2>
          <p className="text-xl text-cream-200 max-w-2xl mx-auto">
            {PROFILE_DATA.bio}
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <div className="glass-card p-8 text-center">
            <div className="text-5xl font-bold gradient-text mb-2">
              {PROFILE_DATA.yearsOfExperience}+
            </div>
            <div className="text-cream-200">Years Experience</div>
          </div>
          
          <div className="glass-card p-8 text-center">
            <div className="text-5xl font-bold gradient-text mb-2">20+</div>
            <div className="text-cream-200">Products</div>
          </div>
          
          <div className="glass-card p-8 text-center">
            <div className="text-5xl font-bold gradient-text mb-2">99.8%</div>
            <div className="text-cream-200">Uptime</div>
          </div>
        </div>

        {/* Tech Stack */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {TECH_STACK.slice(0, 8).map((skill) => (
            <div key={skill.name} className="glass-card p-6 text-center">
              <div className="text-lg font-semibold text-cream-100 mb-1">{skill.name}</div>
              <div className="text-sm text-cream-300">{skill.category}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
